import type { BariatricsExternalReferralData } from '@common/validation/customControls/bariatrics/bariatricsExternalReferral/v1/bariatricsExternalReferralSchema';
import { CustomControlCode } from '@common/enums';
import { CustomControlRegistry } from '@frontend/components/pages/episodeCategory/customControls/customControlRegistry';
import { initialData } from '../../bariatrics/BariatricsExternalReferralData';
import { BariatricsExternalReferralEdit } from '../../bariatrics/BariatricsExternalReferralEdit';
import { BariatricsExternalReferralRead } from '../../bariatrics/BariatricsExternalReferralRead';

CustomControlRegistry.instance.register<BariatricsExternalReferralData>({
    EditElement: BariatricsExternalReferralEdit,
    ReadElement: BariatricsExternalReferralRead,
    code: CustomControlCode.BariPreExternalReferral,
    initialData,
    version: 1,
});
